import React from "react";
import {Dropdown, DropdownItem} from "src/components";
import {Distribution} from "../../model/EstateFlowchartTypes";

type CopyButtonProps = {
    className: string;
    disabled: boolean;
    distributions: Distribution[];
    handleCopyDistribution: (value: string) => void;
    shouldDropdownOpenUp?: boolean;
};

function CopyButtonDropdown({
                                className,
                                disabled,
                                distributions,
                                handleCopyDistribution,
                                shouldDropdownOpenUp = false
                            }: Readonly<CopyButtonProps>): JSX.Element {

    const dropdownItems = distributions
        .filter(({name}) => name)
        .sort((a, b) => a.name?.localeCompare(b.name ?? "") ?? 0)
        .map(({name}) => ({
            itemText: name,
            value: name,
            onClick: () => {},
            disabled: false,
        }));


    return (
        <Dropdown
            className={className}
            alignRight={false}
            buttonKind="borderless"
            dropdownKind="menu"
            defaultText="COPY"
            panelWidth={245}
            disabled={disabled}
            dropUp={shouldDropdownOpenUp}
            onChange={(e) => handleCopyDistribution(e.value)}
        >
            {dropdownItems.map((item: any, i: number) => (
                <DropdownItem
                    key={i}
                    {...item}
                />
            ))}
        </Dropdown>
    );
}

export default CopyButtonDropdown;
